<template>
  <i
    class="icon"
    :class="`icon--${size}`"
    :style="{ '--color': color }"
  >
    <span
      v-if="title"
      class="sr-only"
      >{{ title }}</span
    >
    <slot name="svg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        :viewBox="box"
        role="img"
        class="icon__legacy"
      >
        <slot />
      </svg>
    </slot>
  </i>
</template>

<script>
export default {
  name: 'BaseIcon',
  props: {
    title: {
      type: String,
      default: '',
    },
    // Width and height mostly for custom/legacy icons
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    // Size for material icons with standard sizes
    size: {
      type: String,
      default: 'sm',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    box: {
      type: String,
      default: '0 0 18 18',
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  display: inline-block;
  vertical-align: middle;

  &--xs {
    --size: 16px;
  }

  &--sm {
    --size: 24px;
  }

  &--md {
    --size: 48px;
  }

  &--lg {
    --size: 96px;
  }

  &--xl {
    --size: 182px;
  }

  --height: var(--size);
  --width: var(--size);

  svg {
    display: block;
    pointer-events: none;

    max-width: 100%;
    height: auto;

    fill: var(--color);

    &:not(.icon__legacy) {
      width: var(--width, 24px);
      height: var(--height, 24px);
    }
  }
}
</style>
